import DOMPurify from "dompurify";

export const inputOnlyNumbers = (event) => {
  if (
    (event.key >= "0" && event.key <= "9") || // numbers
    event.key === "Backspace" || // backspace
    event.key === "ArrowUp" || // up arrow
    event.key === "ArrowDown" || // down arrow
    event.key === "ArrowLeft" || // left arrow
    event.key === "ArrowRight" // right arrow
  ) {
    return; // do nothing, allow the key press
  }

  event.preventDefault(); // prevent default behavior
};

export const isHaveHTMLElement = (input) => {
  const htmlTagPattern = /<\/?[^>]+(>|$)/;
  return htmlTagPattern.test(input); // Returns true if HTML tags are found
};

export const sanitizeInput = (input) => {
  return DOMPurify.sanitize(input);
};

export const showSanitizedInput = (input) => {
  let sanitizedInput = input.replace(/</g, "&lt;").replace(/>/g, "&gt;");
  return sanitizedInput;
};

export const generateUniqueName = (originalName) => {
  const countRegex = /(.*?)(\s*\((\d+)\))?$/;
  const match = originalName.match(countRegex);

  const baseName = match[1];
  const currentCount = match[3] ? parseInt(match[3], 10) : 0;
  const newCount = currentCount + 1;

  return `${baseName.trim()} (${newCount})`;
};

export const convertSecondsToTime = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return {
    hours,
    minutes,
    seconds,
  };
};

export const fullColorToHex = function (color) {
  const hex = color.hex;
  const alphaHex = Math.round(color.rgb.a * 255).toString(16);
  return `${hex}${alphaHex}`;
};
